import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workdir/node_modules/@babel/runtime/helpers/esm/createClass";

var Rect = /*#__PURE__*/function () {
  _createClass(Rect, null, [{
    key: "zero",
    get: function get() {
      return new Rect();
    }
  }]);

  function Rect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$top = _ref.top,
        top = _ref$top === void 0 ? 0 : _ref$top,
        _ref$left = _ref.left,
        left = _ref$left === void 0 ? 0 : _ref$left,
        _ref$width = _ref.width,
        width = _ref$width === void 0 ? 0 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === void 0 ? 0 : _ref$height;

    _classCallCheck(this, Rect);

    this.top = void 0;
    this.left = void 0;
    this.width = void 0;
    this.height = void 0;
    this.top = top;
    this.left = left;
    this.width = width;
    this.height = height;
  }

  _createClass(Rect, [{
    key: "center",
    get: function get() {
      return {
        x: this.left + this.width / 2,
        y: this.top + this.height / 2
      };
    }
  }]);

  return Rect;
}();

function getRectForNode(node) {
  if (!(node instanceof Element)) {
    return new Rect({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  var rect = node.getBoundingClientRect();
  return new Rect({
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height
  });
}

export { Rect, getRectForNode };